import {SalesDashboardRepository} from '../repository/SalesDashboardRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import type {InvoiceDTO} from '../api/SalesDashboardAPIDataSource';

export class GetInvoicesWithFiltersDashboardUseCase {
  constructor (private readonly repo: SalesDashboardRepository) {}

  async execute (params: Record<string, any>): Promise<BaseResponse<InvoiceDTO[]>> {
    return this.repo.getInvoices(params);
  }
}


